import { Directive, Input, Optional } from '@angular/core';
import { RouterLink, RouterLinkWithHref } from '@angular/router';

@Directive({
  selector: '[routerLink][disableLink]',
  standalone: true
})
export class RouterLinkDisableDirective {

  @Input() disableLink?: boolean;

  constructor(
    @Optional() routerLink: RouterLink,
    @Optional() routerLinkWithHref: RouterLinkWithHref
  ) {
    const link = routerLink || routerLinkWithHref;
    const onClick = link.onClick;

    link.onClick = (...args) => {
      if (this.disableLink) {
        return routerLinkWithHref ? false : true;
      } else {
        return onClick.apply(link, args);
      }
    };
  }
}
